module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_null_null@3x.ae3dce1e.png";